export function sanitize(text: string, maxLen = 4096): string {
  return text.replace(/<[^>]*>/g, '').substring(0, maxLen);
}

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');
}
